import SurveyModal from 'components/Survey/SurveyModal';
import { PageIdProvider } from 'contexts/PageIdContext';
import { SurveyProvider } from 'contexts/SurveyContext';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainPage from 'views/MainPage';
import { MessagePage } from 'views/MessagePage';
import { MobilePage } from 'views/MobilePage';
import { StepsPage } from 'views/StepsPage';
import { TemplatePage } from 'views/TemplatePage';

export function AppRoutes() {
	return (
		<PageIdProvider>
			<SurveyProvider application="powerzap">
				<Routes>
					<Route path={`${process.env.PUBLIC_URL}/`} element={<MainPage />} />
					<Route path={`${process.env.PUBLIC_URL}/mobile`} element={<MobilePage />} />
					<Route path={`${process.env.PUBLIC_URL}/step`} element={<StepsPage />} />
					<Route path={`${process.env.PUBLIC_URL}/message`} element={<MessagePage />} />
					<Route path={`${process.env.PUBLIC_URL}/templates/:token`} element={<TemplatePage />} />
				</Routes>
				<SurveyModal />
			</SurveyProvider>
		</PageIdProvider>
	);
}
